import createIsValid from './selectors/isValid';
import plain from './structure/plain';
export default createIsValid(plain);


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/redux-form/es/isValid.js
// module id = aoA2
// module chunks = 1